import { isTestEnv } from "./env";

export const logResponse = (label, data) => {
  if (isTestEnv()) {
    console.log(`[${label}]`, data);
  }
};
